import { CalendarDays } from "lucide-react";
import { useEffect, useState } from "react";

const ISO_DATE = /^(\d{4})-(\d{2})-(\d{2})$/;
const CIVIL_DATE = /^(\d{2})\/(\d{2})\/(\d{4})$/;

function validDate(year: number, month: number, day: number) {
  const date = new Date(year, month - 1, day);
  return date.getFullYear() === year && date.getMonth() === month - 1 && date.getDate() === day;
}

export function formatExecutionCivilDate(value: string) {
  const match = ISO_DATE.exec(value);
  return match ? `${match[3]}/${match[2]}/${match[1]}` : "";
}

export function parseExecutionCivilDate(value: string) {
  const match = CIVIL_DATE.exec(value.trim());
  if (!match) return null;
  const day = Number(match[1]);
  const month = Number(match[2]);
  const year = Number(match[3]);
  return validDate(year, month, day) ? `${match[3]}-${match[2]}-${match[1]}` : null;
}

export function ExecutionCivilDateInput({ value, onChange, required, min, max, ariaLabel }: {
  value: string;
  onChange: (value: string) => void;
  required?: boolean;
  min?: string;
  max?: string;
  ariaLabel?: string;
}) {
  const [display, setDisplay] = useState(() => formatExecutionCivilDate(value));

  useEffect(() => setDisplay(formatExecutionCivilDate(value)), [value]);

  return <span className="execution-civil-date">
    <input
      type="text"
      inputMode="numeric"
      placeholder="DD/MM/YYYY"
      maxLength={10}
      required={required}
      pattern="\d{2}/\d{2}/\d{4}"
      aria-label={ariaLabel}
      value={display}
      onChange={(event) => {
        const next = event.target.value;
        setDisplay(next);
        if (!next) onChange("");
        else {
          const parsed = parseExecutionCivilDate(next);
          if (parsed && (!min || parsed >= min) && (!max || parsed <= max)) onChange(parsed);
        }
      }}
      onBlur={() => setDisplay(formatExecutionCivilDate(value))}
    />
    <span className="execution-civil-date-picker">
      <CalendarDays size={18} aria-hidden="true" />
      <input
        type="date"
        tabIndex={-1}
        aria-label={`${ariaLabel || "Fecha"}: abrir calendario`}
        min={min}
        max={max}
        value={value}
        onChange={(event) => onChange(event.target.value)}
      />
    </span>
  </span>;
}
